import { makeStyles, Theme } from "@material-ui/core/styles";

const useAppBarHeaderStyles = makeStyles((theme: Theme) => ({
	root: {
		flexGrow: 1,
		flexDirection: "row",
		display: "flex",
		alignItems: "center",
		marginLeft: theme.spacing(1),
	},
	logo: {
		width: "184px",
		height: "30px",
		marginRight: theme.spacing(4),
		marginTop: theme.spacing(1),
		[theme.breakpoints.only("xs")]: {
			width: "0px",
			height: "0px",
			marginRight: 0,
			marginTop: 0,
		},
	},
}));
export default useAppBarHeaderStyles;
